var numberFormatEuroOptions = {
    numberOfDecimals: 0,
    decimalSeparator: ',',
    thousandSeparator: '.'
};

$(document).ready(function(){
	// Uniform JS\
	if($.uniform)
		$(".compare-table select").uniform();
	
	formatter = new Formatter();
});

var formatter;
function updateKwijtscheldingOverlijden()
{
	console.log("Formatter.euro", formatter.euro);
	// Data welke naar de server verzonden moet worden
	var data = {
		partner: $("select[name=1_BurgerlijkeStaat]").val() == "02" || $("select[name=1_BurgerlijkeStaat]").val() == "03" ? true : false,
    	bedrag: formatter.euro.get($(".leenbedrag:visible").first()),
    	looptijd: $("select[name=productvorm]").val() == "Doorlopend krediet" ? formatter.months.get($("input[name=Doorlopendkrediet-DuurInMnd]")) : formatter.months.get($("input[name=Persoonlijkelening-DuurInMnd]")),
    	product: $("select[name=productvorm]").val() == "Doorlopend krediet" || $("select[name=productvorm]").val() == "Combinatie krediet" || $("select[name=productvorm]").val() == "Verbouwingskrediet" ? "doorlopend" : "persoonlijk",
    	mainPerson: {
    		roken: $("#JRoken_1").prev().hasClass("checked"),
    		birthday: $("input[name=1_GeboorteDt]").val(),
    		gender: $("select[name=1_Geslacht]").val() == "M" ? "M" : "F"
    	},
    	secondPerson: {
    		roken: $("#JRoken_2").prev().hasClass("checked"),
    		birthday: $("input[name=2_GeboorteDt]").val(),
    		gender: $("select[name=2_Geslacht]").val() == "M" ? "M" : "F"
    	}
    	// ,
    	//dekkingTerminaleZiekte: $("#JTerminaleZiekte").prev().hasClass("checked"),
    	//dekkingOngevallen: $("#JOngevallen").prev().hasClass("checked"),
    	//dekkingKinderen: $("#JDekkingKinderen").prev().hasClass("checked"),
    	//premieVrijstelling: $("#JPremieVrijstelling").prev().hasClass("checked"),
    };
	
	// Enkele velden moeten verplicht gevuld zijn
	if(data.bedrag && data.looptijd && data.product && data.mainPerson.birthday)
	{
    	$.ajax({
    		url: "/ajax/overlijden.php",
    		data: data,
    		success: function(data)
    		{
    			if(data != "error")
    			{
    				// Als er geen error is slide down de fieldset
    				data = data.split(";");
    				var bedrag = $().number_format(data[0],
	            	{
		                numberOfDecimals:2,
		                decimalSeparator: ',',
		                thousandSeparator: '.'
	            	});
    				if(bedrag != "NaN,00error"){
                        $("#OverlijdenKwijtschelding").slideDown();
                        $("#JOverlijdenKwijtschelding").next().text("Ja (€" + bedrag + " per maand)");
                        $("#OverlijdenKwijtschelding-totaal p").text("Kosten: €" + bedrag + " per maand");
                        $("input[name=OverlijdingsrisicoVerzekering]").val(bedrag + " euro");
                        $("input[name=ORVMaatschappij]").val(data[1] == "ACE" ? "ACE" : "Quantum");
                        $('.errorOverlijden').hide();
                    }else{
                        $("input#NOverlijdenKwijtschelding").attr('checked', true);
                        $("input#JOverlijdenKwijtschelding").attr('checked', false);
                        hideKwijtscheldingOverlijden();
                        $('.errorOverlijden').show();
                    }
    			}
    			else
    			{
    				hideKwijtscheldingOverlijden();
    			}
    		}
    	});
    }
    else
    {
    	hideKwijtscheldingOverlijden();
    }
}

function updateKwijtscheldingOverlijdenWithSelects()
{
    console.log("Formatter.euro", formatter.euro);

    // Data welke naar de server verzonden moet worden
    var data = {
        partner: $("select[name=1_BurgerlijkeStaat]").val() == "02" || $("select[name=1_BurgerlijkeStaat]").val() == "03" ? true : false,
        bedrag: $("select[name=productvorm]").val() == "Doorlopend krediet" || $("select[name=productvorm]").val() == "WOZ krediet" ? formatter.euro.get($("fieldset.doorlopend-krediet .leenbedrag")) : formatter.euro.get($("fieldset.persoonlijke-lening .leenbedrag")),
        looptijd: $("select[name=productvorm]").val() == "Doorlopend krediet" || $("select[name=productvorm]").val() == "WOZ krediet" ? formatter.dk.select.looptijd.get($("fieldset.doorlopend-krediet select[name=Doorlopendkrediet-looptijd]")) : formatter.pl.select.looptijd.get($("fieldset.persoonlijke-lening select[name=Persoonlijkelening-looptijd]")),
        product: $("select[name=productvorm]").val() == "Doorlopend krediet" || $("select[name=productvorm]").val() == "Combinatie krediet" || $("select[name=productvorm]").val() == "WOZ krediet" ? "doorlopend" : "persoonlijk",
        mainPerson: {
            roken: $("#JRoken_1").parent().hasClass("checked"),
            birthday: $('input[name=1_GeboorteDt]').val(),
            gender: $("select[name=1_Geslacht]").val() == "M" ? "M" : "F"
        },
        secondPerson: {
            roken: $("#JRoken_2").parent().hasClass("checked"),
            birthday: $("input[name=2_GeboorteDt]").val(),
            gender: $("select[name=2_Geslacht]").val() == "M" ? "M" : "F"
        }
        //dekkingTerminaleZiekte: $("#JTerminaleZiekte").prev().hasClass("checked"),
        //dekkingOngevallen: $("#JOngevallen").prev().hasClass("checked"),
        //dekkingKinderen: $("#JDekkingKinderen").prev().hasClass("checked"),
        //premieVrijstelling: $("#JPremieVrijstelling").prev().hasClass("checked"),
    };
    console.log(data);
    // Enkele velden moeten verplicht gevuld zijn
    if(data.bedrag && data.looptijd && data.product && data.mainPerson.birthday)
    {
        $.ajax({
            url: "/ajax/overlijden.php",
            data: data,
            success: function(data)
            {
                if(data != "error")
                {
                    // Als er geen error is slide down de fieldset
                    data = data.split(";");
                    var bedrag = $().number_format(data[0],
                    {
                        numberOfDecimals:2,
                        decimalSeparator: ',',
                        thousandSeparator: '.'
                    });
                     if(bedrag != "NaN,00error"){
                        $("#OverlijdenKwijtschelding").slideDown();
                        $("#uniform-JOverlijdenKwijtschelding").next().text("Ja (€" + bedrag + " per maand)");
                        $("#OverlijdenKwijtschelding-totaal p").text("Kosten: €" + bedrag + " per maand");
                        $("input[name=E_OverlijdingsrisicoVerzekering]").val(bedrag + " euro");
                        $("input[name=E_ORVMaatschappij]").val(data[1] == "ACE" ? "ACE" : "Quantum");
                        $('.errorOverlijden').hide();
                    }else{
                        $("input#NOverlijdenKwijtschelding").attr('checked', true);
                        $("input#JOverlijdenKwijtschelding").attr('checked', false);
                        hideKwijtscheldingOverlijden();
                        $('.errorOverlijden').show();
                    }
                }
                else
                {
                    hideKwijtscheldingOverlijden();
                    $('.errorOverlijden').show();
                }
            }
        });
    }
    else
    {
        hideKwijtscheldingOverlijden();
    }
}

function hideKwijtscheldingOverlijden()
{
	// Wanneer niet de juiste velden gevuld zijn, verberg de fieldset
	$("#OverlijdenKwijtschelding").slideUp();
	$("input[name=E_OverlijdingsrisicoVerzekering]").val("Nee");
}

$.fn.selectRange = function(start, end) {
    return this.each(function() {
        if(this.setSelectionRange) {
            this.focus();
            this.setSelectionRange(start, end);
        } else if(this.createTextRange) {
            var range = this.createTextRange();
            range.collapse(true);
            range.moveEnd('character', end);
            range.moveStart('character', start);
            range.select();
        }
    });
};

/**
 * Function to receive the max value for a maandlast based on a looptijd and the given value 
 */
var checkMaandlast = function(value){
	var leenbedrag = this.product.fields.leenbedrag.value;
	var nominaal = this.product.calculator.values.nominaal;
	var looptijd = util.looptijd(leenbedrag, nominaal, value);
	
	if(isNaN(looptijd) || looptijd  > this.product.fields.looptijd.max)
		return util.maandlast(leenbedrag, nominaal, this.product.fields.looptijd.max);
	else if (looptijd < this.product.fields.looptijd.min)
		return util.maandlast(leenbedrag, nominaal, this.product.fields.looptijd.min);
	else
		return value;
};

// In case we forget to take out console statements. IE becomes very unhappy when we forget. Let's not make IE unhappy
if(typeof(console) === 'undefined') {
    var console = {};
    console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time = console.timeEnd = console.assert = console.profile = function() {};
}